export enum EOrigemValorItem {
    Rateio = 1,
    Especifico = 2,
  }
